/**
 * Circular arc power indicator — overlaid on FlickController.
 * Arc length = flick intensity (0-100%), color shifts green→red.
 */

import { computeIntensityColor } from "../utils/canvas-effects";

interface PowerMeterProps {
  readonly size: number;
  readonly intensity: number;
  readonly isActive: boolean;
}

export function PowerMeter({ size, intensity, isActive }: PowerMeterProps) {
  if (!isActive || intensity <= 0) return null;

  const center = size / 2;
  const strokeWidth = 4;
  const radius = center - strokeWidth / 2 - 1;
  const circumference = 2 * Math.PI * radius;
  const arcLength = circumference * Math.min(intensity, 1);
  const color = computeIntensityColor(intensity);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
        transform: "rotate(-90deg)",
      }}
      aria-hidden="true"
    >
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={`${arcLength} ${circumference - arcLength}`}
        strokeLinecap="round"
        style={{
          transition: "stroke-dasharray 0.05s, stroke 0.05s",
          opacity: 0.8,
        }}
      />
    </svg>
  );
}
